import { Alert, Tooltip, Typography, alertClasses, styled } from "@mui/material";
import { forwardRef } from "react";
import { ErrorIcon } from "./StatusIcon";

const AlertStyled = styled(Alert)(() => ({
  [`& .${alertClasses.icon}`]: {
    alignItems: "center",
    fontSize: "15px",
  },
}));

const GqlErrorContent = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, ref) => (
  <div {...props} ref={ref}>
    <ErrorIcon />
  </div>
));
GqlErrorContent.displayName = "GqlErrorContent";

interface GqlErrorProps {
  error?: Error | (Error | undefined)[];
  small?: boolean;
}

const GqlError = ({ small = false }: GqlErrorProps) => {
  if (small) {
    return (
      <Tooltip
        id="tooltip"
        placement="right"
        arrow
        title="There was a problem processing the request. Please try again. Contact support if the problem persists."
      >
        <GqlErrorContent />
      </Tooltip>
    );
  }
  return (
    <AlertStyled severity="error" icon={<ErrorIcon color="accentDanger30" />}>
      <Typography>
        There was a problem processing the request. Please try again. Contact support if the problem persists.
      </Typography>
    </AlertStyled>
  );
};

export { GqlError };
